// Base de données des épices KAZA
// Pour ajouter/modifier une épice, édite ce fichier !

export const epices = [
  {
    id: 'sel-noir-lave',
    nom: 'Sel noir de lave',
    image: '/images/sel-noir-lave.jpg',
    origine: 'Hawaï (États-Unis)',
    bienfaits: 'Riche en minéraux, aide à la digestion, propriétés détoxifiantes.',
    anecdote: 'Le sel noir de lave est enrichi en charbon actif, ce qui lui donne sa couleur et ses propriétés purifiantes. Il est traditionnellement utilisé dans la cuisine hawaïenne.'
  },
  {
    id: 'poivre-lampong',
    nom: 'Poivre long de Lampong',
    image: '/images/poivre-lampong.jpg',
    origine: 'Sumatra (Indonésie)',
    bienfaits: 'Stimulant digestif, riche en antioxydants, favorise la circulation.',
    anecdote: "Le poivre long était utilisé dans la Rome antique avant l'arrivée du poivre noir classique en Europe."
  },
  {
    id: 'poivre-madagascar',
    nom: 'Poivre de Madagascar',
    image: '/images/poivre-madagascar.jpg',
    origine: 'Madagascar',
    bienfaits: 'Antibactérien naturel, stimule l\'appétit, riche en pipérine.',
    anecdote: "Le poivre de Madagascar est réputé pour ses notes boisées et florales uniques, très prisé par les chefs."
  },
  {
    id: 'paprika-fume',
    nom: 'Paprika fumé',
    image: '/images/paprika-fume.jpg',
    origine: 'Espagne',
    bienfaits: 'Riche en vitamine C, antioxydant, stimule le métabolisme.',
    anecdote: 'Le paprika fumé (pimentón) est séché au feu de bois de chêne, ce qui lui donne son arôme caractéristique. Il est essentiel dans la cuisine espagnole.'
  },
  {
    id: 'ail-semoule',
    nom: 'Ail semoule',
    image: '/images/ail-semoule.jpg',
    origine: 'Chine, France',
    bienfaits: 'Renforce le système immunitaire, antibactérien, bon pour le cœur.',
    anecdote: " L'ail est utilisé depuis l'Antiquité pour ses vertus médicinales. Les ouvriers des pyramides d'Égypte en consommaient pour rester en bonne santé."
  },
  {
    id: 'nigelle',
    nom: 'Nigelle',
    image: '/images/nigelle.jpg',
    origine: 'Moyen-Orient',
    bienfaits: 'Antioxydant, anti-inflammatoire, soutient le système immunitaire.',
    anecdote: 'La nigelle est surnommée « graine bénie » dans la tradition musulmane. Elle était retrouvée dans la tombe de Toutankhamon.'
  },
  {
    id: 'gingembre',
    nom: 'Gingembre',
    image: '/images/gingembre.jpg',
    origine: 'Inde, Asie du Sud-Est',
    bienfaits: 'Anti-nauséeux, anti-inflammatoire, stimule la digestion.',
    anecdote: 'Le gingembre est utilisé depuis plus de 5000 ans en médecine ayurvédique et chinoise.'
  },
  {
    id: 'cumin',
    nom: 'Cumin',
    image: '/images/cumin.jpg',
    origine: 'Méditerranée, Inde',
    bienfaits: 'Aide la digestion, riche en fer, propriétés antioxydantes.',
    anecdote: "Le cumin était utilisé dans l'Égypte ancienne pour embaumer les momies."
  },
  {
    id: 'sel-rose-himalaya',
    nom: "Sel rose de l'Himalaya",
    image: '/images/sel-rose-himalaya.jpg',
    origine: 'Pakistan (région du Punjab)',
    bienfaits: "Riche en minéraux, équilibre les électrolytes, favorise l'hydratation.",
    anecdote: "Ce sel s'est formé il y a plus de 250 millions d'années lors de l'assèchement d'une mer préhistorique."
  },
  {
    id: 'poivre-timut',
    nom: 'Poivre de Timut',
    image: '/images/poivre-timut.jpg',
    origine: 'Népal',
    bienfaits: 'Effet tonique, riche en antioxydants, notes citronnées stimulantes.',
    anecdote: "Le poivre de Timut n'est pas un vrai poivre mais une baie de la famille des Zanthoxylum, comme le poivre du Sichuan."
  },
  {
    id: 'cardamome',
    nom: 'Cardamome',
    image: '/images/cardamome.jpg',
    origine: 'Inde, Guatemala',
    bienfaits: 'Facilite la digestion, rafraîchit l\'haleine, antioxydant.',
    anecdote: 'La cardamome est surnommée « reine des épices » en Inde. Elle est utilisée dans le café arabe et les desserts scandinaves.'
  },
  {
    id: 'coriandre',
    nom: 'Coriandre',
    image: '/images/coriandre.jpg',
    origine: 'Méditerranée, Moyen-Orient',
    bienfaits: 'Détoxifiante, riche en vitamines, aide à la digestion.',
    anecdote: "La coriandre est l'une des plus anciennes herbes connues, mentionnée dans des textes sanskrits et la Bible."
  },
  {
    id: 'sumac',
    nom: 'Sumac',
    image: '/images/sumac.jpg',
    origine: 'Moyen-Orient',
    bienfaits: 'Antioxydant, aide à contrôler la glycémie, propriétés anti-inflammatoires.',
    anecdote: "Le sumac était utilisé dans l'Antiquité pour acidifier les plats avant l'arrivée du citron en Europe."
  },
  {
    id: 'basilic',
    nom: 'Basilic',
    image: '/images/basilic.jpg',
    origine: 'Inde, Méditerranée',
    bienfaits: 'Riche en antioxydants, propriétés anti-inflammatoires, favorise la digestion.',
    anecdote: 'Le basilic est sacré en Inde et symbole d\'amour en Italie.'
  },
  {
    id: 'sel-rouge-hawai',
    nom: "Sel rouge d'Hawaï",
    image: '/images/sel-rouge-hawai.jpg',
    origine: 'Hawaï (États-Unis)',
    bienfaits: 'Riche en minéraux, saveur douce, propriétés purifiantes.',
    anecdote: "Le sel rouge d'Hawaï est coloré à l'argile volcanique (Alaea) et utilisé lors de cérémonies traditionnelles."
  },
  {
    id: 'poivre-malabar',
    nom: 'Poivre de Malabar',
    image: '/images/poivre-malabar.jpg',
    origine: 'Côte de Malabar (Inde)',
    bienfaits: 'Stimulant digestif, riche en pipérine, antioxydant.',
    anecdote: "Le poivre de Malabar est considéré comme l'un des meilleurs poivres noirs au monde."
  },
  {
    id: 'piment-jamaique',
    nom: 'Piment de la Jamaïque',
    image: '/images/piment-jamaique.jpg',
    origine: 'Jamaïque, Amérique centrale',
    bienfaits: 'Antiseptique, facilite la digestion, propriétés analgésiques.',
    anecdote: "Appelé aussi « allspice », il rappelle la cannelle, la muscade et le clou de girofle."
  },
  {
    id: 'thym',
    nom: 'Thym',
    image: '/images/thym.jpg',
    origine: 'Méditerranée',
    bienfaits: 'Antiseptique naturel, bon pour la gorge, facilite la digestion.',
    anecdote: "Le thym était brûlé dans l'Antiquité pour purifier l'air et chasser les mauvais esprits."
  },
  {
    id: 'romarin',
    nom: 'Romarin',
    image: '/images/romarin.jpg',
    origine: 'Méditerranée',
    bienfaits: 'Stimulant, améliore la mémoire, antioxydant.',
    anecdote: "Le romarin était utilisé par les étudiants grecs pour booster leur mémoire avant les examens."
  }
];

export const getEpiceById = (id) => epices.find(e => e.id === id); 